export default "__VITE_ASSET__CnoQMBCV__"